// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","455":"1b55a24f","977":"fb55a997"}[chunkId] + ".chunk.js";
};